export default __webpack_public_path__ + "static/media/FrontEndJSReact.a4adb9cd.png";